import { render, staticRenderFns } from "./ModalDownload.vue?vue&type=template&id=556bb43c"
import script from "./ModalDownload.vue?vue&type=script&lang=js"
export * from "./ModalDownload.vue?vue&type=script&lang=js"
import style0 from "./ModalDownload.vue?vue&type=style&index=0&id=556bb43c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports